const MuiChip = {
  root: {
    fontSize: '1.4rem',
  },
};

export default MuiChip;
